import PivotCreate from "./PivotCreateContainer";
export default PivotCreate;
